export default class Row {
  constructor(data, parentVM, node, options) {
    this.defaults = {
      properties: {
        draggable: { enabled: false },
        removable: { enabled: false },
        data_url: ''
      }
    };
    this.config = _.extend({}, this.defaults.properties, options);

    if(this.config.draggable.enabled) {
      this.$el = $(node);
      this.$tbody = $(this.$el).find('.kd-data-table__data');
    }
    this.parentVM = parentVM;
    this.parentVM.prepRowData(data);

    if(this.parentVM.config.column_properties.editable.enabled) {
      this.editing = ko.observable(false);
      this.rowChanged = ko.observable(false);
      this.setupEditableSubscriptions(data);
    }

    _.extend(this, data);
  }

  setupEditableSubscriptions(data) {
    let self = this;
    _.each(data, function(datum) {
      datum.subscribeChanged(function(newValue, oldValue){
        if(newValue !== oldValue){
          self.rowChanged(true);
          self.parentVM.tempOldRowVal(oldValue);
        }
      });
    });

    self.editing.subscribeChanged(function(newValue, oldValue){
      if(!newValue && self.rowChanged()){
        self.saveRow();
        self.rowChanged(false);
      }
    });
  }

  static initDraggable($tbody, url, parentVM) {
    let self = this;
    let $fixedColGroup = $('.kd-data-table__column-fixed-group');

    $tbody.sortable({
      items: '.kd-data-table__row',
      handle: '.kd-data-table__sort-handle',
      axis: 'y',
      start: function(e, ui){
        $fixedColGroup.hide();
      },
      helper: function (e, ui) {
        ui.children().each(function () {
          $(this).width($(this).width());
        });
        return ui;
      },
      update: function (e, ui) {
        let row = ko.dataFor(ui.item[0]);
        row.updateRowOrder(url, row);
        parentVM.rows.valueHasMutated();
      },
      stop: function(){
        $fixedColGroup.find('.kd-data-table__row').css('background-color', '#ffffff');
        $fixedColGroup.show();
      }
    });
  }

  static initDraggableCallbacks($tbody, callbacks) {
    if (_.isFunction(callbacks.mousedown)) {
      setTimeout(function () {
        $tbody.find('.kd-data-table__sort-handle').off('mousedown').on('mousedown', function (e) {
          callbacks.mousedown(e, $tbody);
        });
      }, 300);
    }
  }

  static setRowBgColor(element, index, fixedRowMode, color) {
    let $flexRows = $('.kd-data-table__column-flex-group .kd-data-table__row');
    let $fixedRows = $('.kd-data-table__column-fixed-group .kd-data-table__row');
    $(element).css('background-color', color);
    if(fixedRowMode) {
      $flexRows.eq(index).css('background-color', color);
    } else {
      $fixedRows.eq(index).css('background-color', color);
    }
  }

  addRowHoverState(element, index, fixedRowMode) {
    Row.setRowBgColor(element, index, fixedRowMode, '#f4f4f4');
  }

  removeRowHoverState(element, index, fixedRowMode) {
    Row.setRowBgColor(element, index, fixedRowMode, '#ffffff');
  }

  copyRow(row, url, copyPrompt) {
    let self = row;
    Kadenze.UIUtil.confirmAction(copyPrompt, function() {
      Kadenze.UIUtil.showLoadingIndicator(row.parentVM.$el);
      let request = new Kadenze.AjaxRequest({
        url: url,
        type: 'POST',
        timeout: 60000
      });

      request.done(function(data) {
        console.log(data);
        let params = {
          'page': self.parentVM.selectedPage(),
          'per': self.parentVM.selectedPer()
        };
        self.parentVM.getRowData(self.config.data_url, params);
        new Kadenze.Notice.success({ message: data.message });
      });

      request.fail(function(xhr, textstatus, message) {
        Kadenze.UIUtil.hideLoadingIndicator(self.parentVM.$el);
        if (textstatus === 'timeout') {
          console.warn('Ajax request timed out:');
          console.log(xhr);
          new Kadenze.Notice.error($.extend({}, {}, {message: Kadenze.I18n.t('notice.unexpected_error')}));
        } else {
          new Kadenze.Notice.error(xhr.responseJSON);
        }
      });
    });
  }

  removeRow(data, evt, deletePrompt='') {
    let self = this;
    let parentVM = ko.contextFor(evt.target).$parent;
    let $el = $(evt.target);
    let url = $el.attr('data-href');
    let fixedRow = $el.parents()[1];
    let targets = $('.kd-data-table__column-flex-group .kd-data-table__row').eq($(fixedRow).index());
    targets.push(fixedRow);

    if(_.isEmpty(deletePrompt)) {
      this.deleteCallback(data, parentVM, url, targets);
    } else {
      Kadenze.UIUtil.confirmAction(deletePrompt, function() {
        self.deleteCallback(data, parentVM, url, targets);
      });
    }
  }

  deleteCallback(row, self, url, targets) {
    let $el = row.parentVM.$el;
    Kadenze.UIUtil.showLoadingIndicator($el);
    let request = new Kadenze.AjaxRequest({
      url: url,
      type: 'DELETE'
    });

    request.done(function(data) {
      Kadenze.UIUtil.hideLoadingIndicator($el);
      console.log(data);
      TweenLite.to(targets, 500 * 0.001, { height: 0, padding: '0 32px', autoAlpha: 0 }).eventCallback('onComplete', function() {
        self.rows.remove(data);
      });
      row.updateRowOrder(row.config.draggable.update_url, row, true);
      self.totals(self.totals() - 1);
      new Kadenze.Notice.success({ message: data.message });
    });

    request.fail(function(data) {
      Kadenze.UIUtil.hideLoadingIndicator($el);
      console.log(data);
      new Kadenze.Notice.error({ message: data.responseJSON.errors });
    });
  }

  saveRow() {
    let self = this;
    let mapping = {
      'ignore': ['$el', '$tbody', 'client_errors', 'config', 'defaults', 'editing', 'parentVM', 'isValid', 'actions']
    };
    let data = ko.mapping.toJS(this, mapping);
    let url = this.config.data_url + '/' + data.id;
    data = this.parentVM.cleanRowEditingData(this, data);

    let request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url: url,
      data: data,
      timeout: 60000
    });

    request.done(function(response, status, xhr) {
      new Kadenze.Notice.success({ message: response.message });
      //console.log('saved');
    });

    request.fail(function(xhr, status, msg) {
      this[this.parentVM.lastChangedCol()](this.parentVM.tempOldRowVal());
      new Kadenze.Notice.error({message: xhr.responseJSON.errors});
    }.bind(self));
  }

  sortRowOrders(self, updatedOrder) {
    const origArr = self.parentVM.orderList;
    let targetArr= [];
    let offset = self.parentVM.selectedPage() == 1 ? 0 : self.parentVM.selectedPer() * (self.parentVM.selectedPage() - 1);
    // _.union looks at each array given to it in the order it's given
    // if the user is on the first page, just send the visible rows
    // otherwise find the offset in the master id array, then union in the correct order:
    // first half, your new half, and the third half
    if(offset == 0){
      return _.union(updatedOrder, self.parentVM.orderList);
    } else {
      let firstHalf = _.first(self.parentVM.orderList, offset);
      let sortedHalf = _.rest(self.parentVM.orderList, offset);
      return _.union(firstHalf, updatedOrder, sortedHalf);
    }
  }

  updateRowOrder(url, self, deleted=false) {
    Kadenze.UIUtil.showLoadingIndicator(self.parentVM.$el);
    let data, updatedOrder;
    if(deleted) {
      updatedOrder = _.reject(self.parentVM.orderList, function(r) { return r == self.id().toString(); });
      self.parentVM.orderList = updatedOrder;
    } else {
      updatedOrder = self.sortRowOrders(self, self.$tbody.sortable('toArray'));
    }

    data = this.parentVM.cleanRowSortingData(this, updatedOrder);
    let request = new Kadenze.AjaxRequest({
      url: url,
      type: 'POST',
      dataAsJSON: false,
      dataType: 'text',
      data: data,
      loadingIndicator: {
        container: '#main-container'
      }
    });

    request.done(function(response, textStatus, xhr) {
      new Kadenze.Notice.success({ message: response.message });
      let params = {
        'page': self.parentVM.selectedPage(),
        'per': self.parentVM.selectedPer()
      };
      self.parentVM.getRowData(self.parentVM.config.row_properties.data_url, params);
    });

    request.fail(function(xhr, textStatus, errorThrown) {
      self.$tbody.sortable('cancel');
      new Kadenze.Notice.error({ message: Kadenze.I18n.t('notice.unexpected_error') });
    });
  }

  editingTypeClass(row) {
    let self = row;
    return ko.pureComputed(function(){
      if(row.editing()){
        return 'is-editing-' + self.parentVM.editingType();
      }
    }, this);
  }
}
